/**
 * Browser storage that never throws.
 *
 * Storage can be unavailable (private mode, blocked site data, sandboxed
 * previews). Everything stored through here is a per-viewer convenience, so an
 * unavailable store degrades to "no remembered value", never to a crash.
 */
type Area = 'local' | 'session';

const area = (which: Area): Storage | null => {
  try {
    return which === 'local' ? window.localStorage : window.sessionStorage;
  } catch {
    return null;
  }
};

export const readStored = (key: string, which: Area = 'local'): string | null => {
  try {
    return area(which)?.getItem(key) ?? null;
  } catch {
    return null;
  }
};

export const writeStored = (key: string, value: string, which: Area = 'local'): void => {
  try {
    area(which)?.setItem(key, value);
  } catch {
    // Ignored: remembered state is an optimisation, not a requirement.
  }
};

export const removeStored = (key: string, which: Area = 'local'): void => {
  try {
    area(which)?.removeItem(key);
  } catch {
    // Ignored: see writeStored.
  }
};
